var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 6.66667V8H5.16667C4.85725 8 4.5605 8.12291 4.34171 8.34171C4.12291 8.5605 4 8.85725 4 9.16667V12.8333C4 13.4773 4.52267 14 5.16667 14H10.8333C11.1427 14 11.4395 13.8771 11.6583 13.6583C11.8771 13.4395 12 13.1427 12 12.8333V9.16667C12 8.85725 11.8771 8.5605 11.6583 8.34171C11.4395 8.12291 11.1427 8 10.8333 8H10.6667V6.66667C10.6667 5.95942 10.3857 5.28115 9.8856 4.78105C9.38553 4.28095 8.70725 4 8 4C7.29275 4 6.61448 4.28095 6.11438 4.78105C5.61429 5.28115 5.33333 5.95942 5.33333 6.66667ZM9.66667 8V6.66667C9.66667 6.22464 9.49107 5.80071 9.17851 5.48815C8.86595 5.17559 8.44203 5 8 5C7.55797 5 7.13405 5.17559 6.82149 5.48815C6.50893 5.80071 6.33333 6.22464 6.33333 6.66667V8H9.66667ZM10.6667 9H10.8333C10.8775 9 10.9199 9.01756 10.9512 9.04881C10.9825 9.08007 11 9.12247 11 9.16667V12.8333C11 12.8775 10.9825 12.9199 10.9512 12.9512C10.9199 12.9825 10.8775 13 10.8333 13H5.16667C5.12247 13 5.08007 12.9825 5.04881 12.9512C5.01756 12.9199 5 12.8775 5 12.8333V9.16667C5 9.12247 5.01756 9.08007 5.04881 9.04881C5.08007 9.01756 5.12247 9 5.16667 9H10.6667Z",
    fill: "#D6E7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.236aa551f6ae9949959d99d95c14ac0a.svg";
export { ForwardRef as ReactComponent };